import { createCustomInterceptorInstance } from '@fundacao/shared-components/esm/ie/renovacao';
import axios, { AxiosInstance } from 'axios';
import { paginatedResponse } from 'models/campanhas';

class CampanhaService {
  private documentsApi: AxiosInstance;

  private instance: AxiosInstance;

  private userSession: AxiosInstance;

  constructor() {
    this.instance = createCustomInterceptorInstance(
      process.env.REACT_APP_CAMPANHA_API,
    );
    this.userSession = createCustomInterceptorInstance(
      process.env.REACT_APP_USER_SESSION_API,
    );
    this.documentsApi = createCustomInterceptorInstance(
      process.env.REACT_APP_DOCUMENTS_API,
    );
  }

  private idGrupo =
    localStorage.getItem('usuarioIES') &&
    JSON.parse(localStorage.getItem('usuarioIES') || '')?.idGrupoIES;

  async criarCampanha(campanha) {
    const resp = await this.instance
      .post(
        `/campanhas-marketing/criar/${this.idGrupo}
      `,
        campanha,
      )
      .catch((err) => Promise.reject(err.response));
    return resp.data;
  }

  async validateLgpd() {
    const resp = await this.instance
      .get(
        `/aceite-lgpd/validar
      `,
      )
      .catch((err) => Promise.reject(err.response));
    return resp.data;
  }

  async acceptLgpd() {
    const resp = await this.instance
      .post(
        `/aceite-lgpd/
      `,
      )
      .catch((err) => Promise.reject(err.response));
    return resp.data;
  }

  async getCampanhas(
    pageNumber: number,
    filters?: { grau?: string; status?: string; nome?: string },
  ): Promise<paginatedResponse> {
    const resp = await this.instance
      .get(
        `/campanhas-marketing/lista-campanhas/${this.idGrupo}/${pageNumber}
      `,
        { params: filters },
      )
      .catch((err) => Promise.reject(err.response));
    return resp.data;
  }

  async deleteCampanha(campaignId: string) /* : Promise<TipoProduto[]> */ {
    const resp = await this.instance
      .put(
        `/campanhas-marketing/excluir/${campaignId}
      `,
      )
      .catch((err) => Promise.reject(err.response));
    return resp.data;
  }

  async sendCsvData(
    campaignId: number,
    csvFile: File,
    onProgress: (event) => void,
  ) {
    const formData = new FormData();
    formData.append('file', csvFile);
    const resp = await this.instance
      .post(
        `/documentos-campanhas/v2/${this.idGrupo}/${campaignId}
      `,
        formData,
        {
          onUploadProgress: (event) => {
            onProgress(event);
          },
        },
      )
      .catch((err) => Promise.reject(err.response));
    return resp.data;
  }

  async getBlockedDates() {
    const resp = await this.userSession
      .get(`/calendario`)
      .catch((err) => Promise.reject(err.response));
    return resp.data;
  }

  async getErrorsCsv(errorList: unknown[]) {
    const resp = await this.instance
      .post('/documentos-campanhas/v2/gerar-csv', errorList)
      .catch((err) => Promise.reject(err.response));

    return resp.data;
  }

  async getRelatorioCampanha(idRelatorio: number) {
    const resp = await this.instance
      .get(`/relatorio-campanha/${idRelatorio}`)
      .catch((err) => Promise.reject(err.response));
    return resp.data;
  }

  async getArquivosRelatorio(idArquivo: number) {
    const resp = await this.documentsApi
      .post(`/relatorio-campanhas/buscar/${idArquivo}`, null, {
        responseType: 'blob',
      })
      .catch((err) => Promise.reject(err.response));
    return resp.data;
  }

  async saveRelatorioCampanhas(
    campaignId: number,
    totalLines: number,
    errorLines: number,
    successLines: number,
    csv: File,
    pdf: File,
  ) {
    const formData = new FormData();
    formData.append('campaignId', campaignId.toString());
    formData.append('totalLines', totalLines.toString());
    formData.append('errorLines', errorLines.toString());
    formData.append('successLines', successLines.toString());
    if (csv) {
      formData.append('csv', csv);
    }
    formData.append('pdf', pdf);

    const resp = await this.documentsApi
      .post(`/relatorio-campanhas`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .catch((err) => Promise.reject(err.response));
    return resp.data;
  }
}

export default new CampanhaService();
